import React from 'react';
import { StarIcon } from 'lucide-react';
import { Section } from './Section';
import { SectionCta } from './SectionCta';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <Section eyebrow="⭐⭐⭐⭐⭐ 4.9/5" title="What other dental professionals are saying" alt data-id="element-230" data-mp="3fym68hdq8w2r">
      <div className="grid gap-4 sm:grid-cols-2" data-id="element-231" data-mp="3azt4fm7sytif">
        {testimonials.map((item, i) => <article key={item.name} className={`rounded-3xl border border-white/10 bg-ink-800 p-5 ${i === testimonials.length - 1 ? 'sm:col-span-2' : ''}`} data-id="element-232" data-mp="36zr0f6elhnzz" data-mpi={i}>
            <div className="flex items-center gap-3" data-id="element-233" data-mp="2x11tg8o8lnyi">
              <img src={item.image} alt={`${item.name}, dental professional`} className="h-14 w-14 shrink-0 rounded-full border-2 border-lime/40 object-cover" loading="lazy" data-id="element-234" data-mp="2s28gqigry0ze" />
              <div className="min-w-0" data-id="element-235" data-mp="q8933qg6j7jj">
                <p className="truncate font-display text-sm text-white sm:text-base" data-id="element-236" data-mp="h5ezbmd4bx17">{item.name}</p>
                <p className="truncate text-xs text-white/55" data-id="element-237" data-mp="m5kmoqccuxdh">{item.country}</p>
                <div className="mt-1 flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-238" data-mp="77s943qdcj1x">
                  {Array.from({
                length: 5
              }).map((_, s) => <StarIcon key={s} className="h-3.5 w-3.5 fill-lime text-lime" data-id="element-239" data-mp="c7myu3yer2le" data-mpi={s} />)}
                </div>
              </div>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-white/75" data-id="element-240" data-mp="14v9be1pm5hke">“{item.quote}”</p>
          </article>)}
      </div>

      <SectionCta headline="Join the dental professionals already planning with the system." data-id="element-241" data-mp="q5lcf74wmuzu" />
    </Section>;
}